var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"header"}},[_c('div',[_vm._t("left")],2),_c('div',{staticClass:"font-title-normal"},[_vm._t("title")],2),_c('div',{staticClass:"font-small"},[_vm._t("right")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }